
import { Component, Vue } from "vue-property-decorator";
import { clearFilter } from "@/utils/base";
import { PostLogin } from "@/request/common";
import Remember from "../remember.vue";
import { Md5 } from "ts-md5";
import { GetVersionList } from "@/request/version";
@Component({
  components: {
    Remember,
  },
})
export default class Login extends Vue {
  private logoUrl: any = "/theme/logo2.png"; // 默认图标
  private type: any = "text";
  private ifRember: any = true;
  private visible: any = false;
  private window: any = window;
  private FingerName: any = '';
  private loginInfo: any = {
    用户名: "",
    密码: "",
  };

  private paws: any = [];
  private showPassword: any = false;
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private async checkFinger() {
    const loading = this.$loading({
      lock: true,
      text: "指纹验证中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const res = await window.electronMyAPI.checkFinger('login');
    loading.close();
    console.log('指纹验证结果');
    console.log(res);
    if (res.includes('success')) {
      // 返回结果success&cj2& ....,需要截取&和&之间的内容
      // this.loginInfo['用户名'] = res.split('&')[1];
      this.loginInfo['用户名'] = this.FingerName;
      this.loginInfo['密码'] = 'admin123456';
      this.preLogon();
    } else {
      this.$message.warning('指纹验证失败');
    }
  }
  private changeEye(val: any) {
    // this.showPassword = val;
    // if (val) {
    //   this.type = "text";
    // } else {
    //   this.type = "password";
    // }
  }
  private pawInput(e: any) {
    if (this.loginInfo["密码"] && !this.showPassword) {
      this.type = "password";
    } else {
      this.type = "text";
    }
  }
  private focus() {
    if (localStorage.getItem("cepingpaws")) {
      this.paws = JSON.parse(localStorage.getItem("cepingpaws") || "");
    }
  }
  private update(e: any) {
    this.type = "password";
    this.loginInfo["用户名"] = e.name;
    this.loginInfo["密码"] = e.paw;
    this.visible = false;
  }
  private delPaw(e: any) {
    if (e.length == 0) {
      this.type = "text";
    }
    this.paws = JSON.parse(JSON.stringify(e));
  }
  /** */
  private async preLogon() {
    if (this.systemInfo.SETTING && this.systemInfo.SETTING["ifVerify"]) {
      const loading = this.$loading({
        lock: true,
        text: "权限验证中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const res = await window.electronMyAPI.checkVerify();
      console.log("返回结果");
      console.log(res);
      if (res !== "success") {
        loading.close();
        this.$confirm("授权文件检测失败，可能是未授权或授权文件丢失", "", {
          customClass: "commonConfirm",
          cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
          cancelButtonText: "我知道了",
          showConfirmButton: false,
        });
        return;
      } else {
        loading.close();
      }
    }
    if (this.systemInfo.SETTING && this.systemInfo.SETTING["ifVerifyLight"]) {
      const loading = this.$loading({
        lock: true,
        text: "灯光验证中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const res = await window.electronMyAPI.checkLight("");
      console.log("返回结果");
      console.log(res);
      if (res.includes("success")) {
        console.log("查询设备成功");
        // this.login();
        // 打开紫外灯
        const res2 = await window.electronMyAPI.changeLight("紫外光-ON");
        if (res2) {
          this.$store.commit("updateIfShowZiwai", true);
          console.log(res2);
          loading.close();
          this.login();
        }
      } else {
        loading.close();
        console.log("灯光检测失败，可能是望诊设备未开机或是未连接");
        this.$confirm("灯光检测失败，可能是望诊设备未开机或是未连接", "", {
          customClass: "commonConfirm",
          cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
          cancelButtonText: "我知道了",
          showConfirmButton: false,
        });
      }
    } else {
      this.login();
    }
  }
  /**
   * @description 登录
   */
  private login(): void {
    if (!this.loginInfo["用户名"]) {
      this.$message.warning("请输入用户名");
      return;
    }
    if (!this.loginInfo["密码"]) {
      this.$message.warning("请输入密码");
      return;
    }
    const params: any = {
      username: this.loginInfo["用户名"],
      password: Md5.hashStr(this.loginInfo["密码"]),
    };
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    PostLogin(this, params, loading)
      .then((res: any) => {
        loading.close();
        const d = res.data;
        const token = d.access;
        const user = d;
        this.$store.commit("updateToken", token);
        this.$store.commit("updateUser", user);
        if (this.ifRember) {
          // 如果没有存过则储存，如果已经储存过则更新
          if (this.paws.length === 0) {
            this.paws.push({
              name: this.loginInfo["用户名"],
              paw: this.loginInfo["密码"],
            });
          } else {
            let ifRepeat: any = false;
            let i: any = "";
            this.paws.forEach((ele: any, index: any) => {
              if (ele.name == this.loginInfo["用户名"]) {
                i = index;
                ifRepeat = true;
              }
            });
            if (ifRepeat) {
              this.paws.splice(i, 1);
            }
            this.paws.push({
              name: this.loginInfo["用户名"],
              paw: this.loginInfo["密码"],
            });
          }
        }
        localStorage.setItem("cepingpaws", JSON.stringify(this.paws));
        this.goPage();
      })
      .catch(() => {
        loading.close();
      });
  }
  private goPage() {
    if (
      this.systemInfo.SETTING &&
      this.systemInfo.SETTING.defaultLanguage &&
      this.systemInfo.SETTING.defaultLanguage == "English"
    ) {
      this.$store.commit("updateLanguage", "English");
    } else {
      this.$store.commit("updateLanguage", "Chinese");
    }

    clearFilter();
    if (this.systemInfo.GLOBAL_SYSTEM == "管理端") {
      this.$router.push("/main/evaluation/list");
    } else if (this.systemInfo.GLOBAL_SYSTEM == "医生端") {
      this.$router.push("/main/manage/folder");
    }
  }

  private mounted() {
    this.paws = [];
    if (localStorage.getItem("cepingpaws") && this.systemInfo.SETTING && this.systemInfo.SETTING.ifRememberPassword) {
      this.paws = JSON.parse(localStorage.getItem("cepingpaws") || "");
      if (this.paws.length > 0 && this.systemInfo.SETTING && this.systemInfo.SETTING.ifRememberPassword) {
        this.update(this.paws[this.paws.length - 1]);
      }
    }
    if (this.systemInfo.SETTING && this.systemInfo.SETTING.ifDesktop && this.systemInfo.SETTING.ifAutoUpdate) {
      console.log("自动更新");
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      let params: any = {
        params: {
          name: "测评系统",
        },
      };
      GetVersionList(this, params, loading).then((res: any) => {
        console.log(res);
        const version = this.systemInfo.VERSION;
        console.log("当前版本");
        console.log(version);
        if (
          res.items &&
          res.items.length > 0 &&
          res.items[0]["fields"] &&
          res.items[0]["fields"]["软件版本号"] &&
          res.items[0]["fields"]["软件版本号"].length > 0 &&
          res.items[0]["fields"]["软件版本号"][0].text
        ) {
          console.log("最新版本");
          const cVersion = res.items[0]["fields"]["软件版本号"][0].text;
          console.log(cVersion);
          if (cVersion && cVersion != version) {
            this.$confirm("有新版本，是否更新？", "", {
              customClass: "commonConfirm",
              confirmButtonClass: "iconfont icon-anniu4 confirmSure",
              cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
              cancelButtonText: "不更新",
              confirmButtonText: "更新",
              // showCancelButton: false,
              closeOnClickModal: false,
              // closeOnPressEscape: false,
            }).then(() => {
              const url = res.items[0]["fields"]["软件版本URL"].link;
              console.log(url);
              // 使用 Electron 的下载 API
              let downloadLoading = this.$loading({
                lock: true,
                text: "下载中，请稍候...",
                spinner: "el-icon-loading",
                customClass: "loadClass",
                background: "rgba(255, 255, 255, 0.7)",
              });
              window.electronMyAPI
                .downloadFile(url)
                .then((result: any) => {
                  downloadLoading.close();
                  if (result.success) {
                    this.$message.success("下载成功，正在打开...");
                    let openLoading = this.$loading({
                      lock: true,
                      text: "打开中，请稍候...",
                      spinner: "el-icon-loading",
                      customClass: "loadClass",
                      background: "rgba(255, 255, 255, 0.7)",
                    });
                    window.electronMyAPI
                      .openPath(result.path)
                      .then(() => {
                        openLoading.close();
                      })
                      .catch(() => {
                        openLoading.close();
                      });
                  } else {
                    this.$message.error("下载失败：" + result.message);
                  }
                })
                .catch((error: any) => {
                  downloadLoading.close();
                  this.$message.error("下载出错：" + error);
                });
            }).catch(() => {
              // 用户取消更新，不做任何处理
              console.log("用户取消更新");
            });
          }
        }
      });
    }
    if (this.systemInfo.SETTING && !this.systemInfo.SETTING.ifRememberPassword) {
      this.ifRember = false;
    }
    // 如果指纹登录，则需要读取本地文件拿用户名填充
    if (this.systemInfo.SETTING && this.systemInfo.SETTING.ifFingerprint) {
      window.electronMyAPI.readTextFile("D:/TCMALL/login_name.conf")
        .then((res: any) => {
          console.log("读取本地指纹文件成功");
          console.log(res);
          if (res && typeof res === 'string') {
            this.loginInfo["用户名"] = res;
            this.FingerName = res;
          }
        })
        .catch((error: any) => {
          console.error("读取指纹配置文件失败:", error);
        });
    } else {
      console.log("指纹登录未启用或设置不存在");
    }
  }
}
